import React from 'react'

import { useChat } from '../../chat-context'
import MenuItem from '~components/shared/menu/menu-item'
import { IoCheckbox, IoSquareOutline } from 'react-icons/io5'

export default function ShowSystemMessagesCheckbox() {
    const { showSystem, setShowSystem } = useChat()

    return (
        <MenuItem
            icon={showSystem ? IoCheckbox : IoSquareOutline}
            onClick={() => {
                setShowSystem(!showSystem)
            }}
            iconProps={{
                color: showSystem ? 'brand.500' : 'gray.400',
            }}
        >
            Show System Messages?
        </MenuItem>
    )
}
